// {RpckApi.ts}
import axios from 'axios';
import { RpckVersionResponse, RpckUploadResponse } from 'quanterix-protos/shared/v1/rpck';


// Reverse proxy to localhost:{RPCK_PORT}/rpck
// Configured for local dev in vite.config.ts
// Configured for cloud deployment in Caddyfile
const rpckUpload = '/rpck/upload';
const rpckVersion = '/rpck/version';
const fscUpload = '/rpck/upload/fcs';

export default async function UploadRpck(files: FileList | File[]) {
    const form = new FormData();
    form.append('rpck_file', files[0]);
   
  const response = await axios.post(rpckUpload, form, {responseType: 'blob'});
  
  const buffer = await response.data.arrayBuffer();
  const arr = new Uint8Array(buffer);

  const uploadResponse = RpckUploadResponse.decode(arr);
  
  return uploadResponse;
}

export async function GetRpckServiceVersion() {
  const response = await axios.get(rpckVersion, {responseType: 'blob'});
  const buffer = await response.data.arrayBuffer();
  const arr = new Uint8Array(buffer);
  const versionResponse = RpckVersionResponse.decode(arr);

  return versionResponse;
}
export async function UploadCytekFcs(CytekFcsFile: FileList | File[]) {
    const form = new FormData();
    form.append('rpck_file', CytekFcsFile[0]);
    
    try 
    {
      const response = await axios.post(fscUpload, form, { responseType: 'blob' });
      const buffer = await response.data.arrayBuffer();
      const arr = new Uint8Array(buffer);
      const uploadResponse = RpckUploadResponse.decode(arr);
      return uploadResponse;
    }
    catch (error: any) 
    {
      console.error('UploadCytekFcs failed:', {
        status: error.response?.status,
        dataType: typeof error.response?.data,
        data: error.response?.data,
        error: error,
      });

      // Handle known axios response errors
      if (error.response) {
        const status = error.response.status;
        let errorMessage = `Server error: ${status}`;

        // Handle cases where backend sends Blob or string as response
        if (error.response.data instanceof Blob) {
           errorMessage = await error.response.data.text();
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }

        // Map known errors to user-friendly messages
        if (errorMessage.includes('-2147024882')) {
          throw new Error('Upload buffer limit exceeded');
        }
        if (status === 413) {
          throw new Error('Upload failed: File size exceeds the allowed limit');
        }
        if (status === 400) {
          throw new Error(`Bad Request: ${errorMessage}`);
        }

        throw new Error(`Upload failed: ${errorMessage}`);
      }

      // Catch all for unexpected issues
      throw error;
    }
}
